export default __webpack_public_path__ + "static/media/revealed7.e283867c.png";